import React from 'react'
import PropTypes from 'prop-types'
import { Text } from 'pcln-design-system'
import { Content } from '@pcln/ace-content-react'

const PrimaryHeading = ({ children, fallback, name, ...props }) => {
  return (
    <Text color='text' fontSize={[3, 4, 4, 4, 5]} fontWeight='bold' {...props}>
      <Content name={[name]} fallback={fallback} />
      {children}
    </Text>
  )
}

PrimaryHeading.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.string.isRequired,
  name: PropTypes.string
}

export default PrimaryHeading
